import type { Ring } from "../data/site-boundary";
import { resolveMapViewportTarget } from "./map-viewport";

export function collectSiteMapCoords(
  boundaryRing: Ring | null,
  checkpoints: readonly { lat: number; lng: number }[],
  siteCenter?: { lat: number; lng: number } | null,
): [number, number][] {
  const coords: [number, number][] = [];
  if (boundaryRing !== null) {
    for (const position of boundaryRing) {
      coords.push(position);
    }
  }
  if (siteCenter !== null && siteCenter !== undefined) {
    coords.push([siteCenter.lng, siteCenter.lat]);
  }
  for (const checkpoint of checkpoints) {
    coords.push([checkpoint.lng, checkpoint.lat]);
  }
  return coords;
}

export function resolveSiteMapViewport(
  boundaryRing: Ring | null,
  checkpoints: readonly { lat: number; lng: number }[],
  maxZoom = 16,
  siteCenter?: { lat: number; lng: number } | null,
): ReturnType<typeof resolveMapViewportTarget> {
  return resolveMapViewportTarget(
    collectSiteMapCoords(boundaryRing, checkpoints, siteCenter),
    maxZoom,
  );
}
